import { useState, useCallback } from "react";
import { AlertTriangle } from "lucide-react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";

export const useConfirm = () => {
  const [state, setState] = useState(null);

  const confirm = useCallback(
    (opts) => new Promise((resolve) => setState({ ...opts, resolve })),
    []
  );

  const close = (value) => {
    state?.resolve(value);
    setState(null);
  };

  const dialog = (
    <AlertDialog open={!!state} onOpenChange={(o) => !o && close(false)}>
      <AlertDialogContent className="rounded-3xl border-brand/10 bg-white p-8" data-testid="confirm-dialog">
        <AlertDialogHeader>
          <span className="mb-2 flex h-14 w-14 items-center justify-center rounded-2xl bg-cream text-gold">
            <AlertTriangle className="h-7 w-7" />
          </span>
          <AlertDialogTitle className="font-display text-2xl font-extrabold text-forest">
            {state?.title || "Êtes-vous sûr ?"}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-base text-brand-hover">
            {state?.description || "Cette action est définitive et ne pourra pas être annulée."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-4 gap-3 sm:gap-3">
          <AlertDialogCancel
            data-testid="confirm-dialog-cancel"
            className="rounded-full border-brand/30 px-6 py-3 font-mono text-xs uppercase tracking-[0.2em] text-brand hover:bg-mint hover:text-brand"
          >
            Annuler
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() => close(true)}
            data-testid="confirm-dialog-confirm"
            className="rounded-full bg-gold px-6 py-3 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-white shadow-lg shadow-gold/25 hover:bg-gold-hover"
          >
            {state?.action || "Oui, supprimer"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );

  return { confirm, dialog };
};
